<template>
  <div :class="$style.topBar">
    <div :class="$style.bannerBox" @click="toHome">
      <i :class="$style.bannerLogoIcon"></i><span>{{ $t("447ee65591") }}</span>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    toHome() {
      window.location.href = 'https://kdocs.cn'
    }
  }
}
</script>
<style lang="scss" module>
.topBar {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 11;
  height: 46px;
  background: #fff;
  box-shadow: 0 3px 9px 0 rgba(0, 0, 0, 0.1);
}

.bannerBox {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #3d4757;
  font-size: 16px;
  height: 100%;
  margin-left: 16px;
  width: 120px;
}

.bannerLogoIcon {
  display: inline-block;
  background: url(./assets/docs_logo.svg) no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  width: 24px;
  height: 24px;
  min-width: 13.906px;
  min-height: 14.672px;
  margin-right: 10px;
}
</style>
